var SCAAFFCustomerReferSetting = {
    "program": {
        "active": true,
        "shop": "breedology.myshopify.com",
        "incentive": {
            "type": "fixed_amount",
            "value": "6.00",
            "price_rule_id": 1269581644025,
            "coupon": "UPPROMOTE_CUSTOMER_REFERRAL"
        },
        "program": "MTA0NTk4"
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Refer a Friend to Earn 6$",
            "refer_background_color": "#e81d7c",
            "refer_text_color": "#ffffff",
            "web_position": "right-bottom",
            "mobile_position": "right-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "Invite & Get $6.00 off",
            "popup_description": "Send your friends a $6.00 discount off their purchase. Once they make a purchase, you'll earn $6.00 for each order as well! This reward can be redeemed for coupons.",
            "button_text_get_invite": "Get invite link",
            "button_copy_invite": "Copy invite link",
            "popup_background_color": "#e81d7c",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "You got $6.00 Off",
            "shop_description": "Congrats! Your friend has gifted you a coupon. Coupon will be automatically applied at the checkout page.",
            "shop_button_text": "Shop now",
            "shop_background_color": "#e81d7c",
            "shop_text_color": "#ffffff"
        }
    }
}